import React from "react";
import { Box, Grid, Typography, Button, Chip } from "@mui/material";

const PlanCard = ({ title, customers, features, image, isNew }) => {
  return (
    <Grid
      container
      display={"flex"}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            borderRadius: 3,
            boxShadow: 0,
            position: "relative",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #eeececff",
            bgcolor: "#fff",
            // width: "100%",
            // width: { xs: "100%", sm: "90%", md: "80%", lg: "100%" },
            // maxWidth: 340, // 380
            maxWidth: 320, // 380
            m: "auto",
            height: { xs: 300, sm: 300, md: 325, lg: 402 },
            "&:hover": {
              boxShadow: "5px 15px 20px 0px #fff6f1",
              cursor: "pointer",
            },
          }}
        >
          {isNew && (
            <Chip
              label="NEW"
              color="success"
              size="small"
              sx={{ position: "absolute", top: -10, right: -16 }}
            />
          )}

          <Box>
            <Typography
              variant="h6"
              fontWeight="600"
              mb={1}
              fontSize={{ xs: "1rem", sm: "1rem", md: "1.1rem" }}
              fontFamily='"Poppins", serif'
              textAlign="left"
            >
              {title}
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              mb={2}
              fontSize={{
                xs: "0.85rem",
                sm: "0.85rem",
                sm: "0.96rem",
                sm: "0.96rem",
              }}
              fontFamily='"Poppins", serif'
              textAlign="left"
            >
              ⚡ {customers}
            </Typography>

            {features.map((feature, index) => (
              <Box key={index} display="flex" alignItems="center" mb={1}>
                <Typography
                  variant="body2"
                  color="text.primary"
                  fontSize={{ xs: "0.9rem", sm: "1rem" }}
                  fontFamily='"Poppins", serif'
                  textAlign="left"
                >
                  ✅ {feature}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* <Button
            variant="contained"
            sx={{
              mt: 3,
              bgcolor: "#1976d2",
              textTransform: "none",
              fontSize: { xs: "0.85rem", sm: "1rem" },
              py: { xs: 1, sm: 1.5 },
              fontWeight: 600,
              fontFamily: '"Poppins", serif',
            }}
            fullWidth
          >
            Know More
          </Button> */}
        </Box>
      </Grid>
    </Grid>
  );
};

export default PlanCard;
